import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'code': 'String'
};

export default gql(`
	mutation employee_web_authentication( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_web_authentication( ${ HelperGraphql.createVariables( fields ) } ) {
	        error
	        error_type
	    }
	}
`);

